import React, { memo } from "react";

const SkeletonLoader = ({
  width = "100%",
  height = "20px",
  className = "",
  variant = "text", // text, circular, rectangular
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case "circular":
        return {
          borderRadius: "50%",
          width: height,
          height: height,
        };
      case "rectangular":
        return {
          borderRadius: "4px",
        };
      default:
        return {
          borderRadius: "4px",
        };
    }
  };

  return (
    <div
      className={`skeleton-loader ${className}`}
      style={{
        width,
        height,
        backgroundColor: "#f0f0f0",
        backgroundImage:
          "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
        backgroundSize: "200% 100%",
        animation: "skeleton-loading 1.5s infinite",
        ...getVariantStyles(),
      }}
    />
  );
};

export default memo(SkeletonLoader);
